var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M26.2 798V615.6h61.9c3.1-23.7 6.1-47 9.3-71h-71c0-17.5-.5-34.4.1-51.3.7-19.3 11.8-26.5 27.4-27.4 9.2-.5 18.4-.5 27.6-.7 6.1-.1 12.3 0 18.5 0V399c-22.8-.3-45.2-1.5-67.6-.7-16.7.6-32.5 6.3-46.1 16.5-22.8 17.2-32 41.3-33.4 68.7-.9 18.2-.2 36.5-.2 54.8v6.6h-60.6v70.8h60.1v181.9","key":0}),React.createElement("path",{"d":"M26.2 798V615.6h61.9c3.1-23.7 6.1-47 9.3-71h-71c0-17.5-.5-34.4.1-51.3.7-19.3 11.8-26.5 27.4-27.4 9.2-.5 18.4-.5 27.6-.7 6.1-.1 12.3 0 18.5 0V399c-22.8-.3-45.2-1.5-67.6-.7-16.7.6-32.5 6.3-46.1 16.5-22.8 17.2-32 41.3-33.4 68.7-.9 18.2-.2 36.5-.2 54.8v6.6h-60.6v70.8h60.1v181.9l74 .4z","key":1})]);
}

Facebook.defaultProps = {"viewBox":"-107.9 398 207.9 400"};

module.exports = Facebook;

Facebook.default = Facebook;
